<div class="row" style="margin-top: 10px;">
  <div class="col-md-12 text-center" *ngIf="logEventLoading">
    <img style="width: 30px; padding-left: 2px; margin-top: -3px" src="/img/loading.gif" />
  </div>
  <div class="col-md-12" *ngIf="viewModel$ | async as logs">
    <label style="font-weight: 400; line-height: 13px; padding: 0px 6px 0px 6px;">
      <input type="checkbox" [(ngModel)]="hideEventsBeforeAppointment"/>&nbsp;
      Hide events before appointment was created
    </label>
    <div class="btn-group btn-toggle" style="float: right;">
      <button class="btn btn-lg"  (click)="selectedType = 'text'" [ngClass]="{ 'btn-default': selectedType === 'raw', 'btn-primary active': selectedType === 'text'}">Text</button>
      <button class="btn btn-lg" (click)="selectedType = 'raw'" [ngClass]="{ 'btn-default': selectedType === 'text', 'btn-primary active': selectedType === 'raw'}">JSON</button>
    </div>
    <p-table #eventLogTable
             [value]="logs"
             dataKey="eventId"
             rowExpandMode="single"
             selectionMode="single"
             (onRowSelect)="selectedEventLog.emit($event.data); onRowSelect($event)"
             (onRowUnselect)="onRowUnselect($event)"
             tableStyleClass="appointmentLogTable table table-condensed table-fixed-header table-filter header-fixed"
             [style]="{'font-family': 'Play, sans-serif;'}"
             >
      <ng-template pTemplate="header">
        <tr class="table-header-upper-row">
          <th class="th-upper" style="width: 10%">Type</th>
          <th class="th-upper" style="width: 15%">Timestamp</th>
          <th class="th-upper" style="width: 75%;">Message</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-log let-columns="columns">
        <tr [pSelectableRow]="log[selectedType]"
            [pRowToggler]="log"
            class="table-row ui-selectable-row"
            *ngIf="(hideEventsBeforeAppointment &&
            (log[selectedType].timestamp >= selectedAppointment.createdMs)) || (!hideEventsBeforeAppointment)"
            [ngClass]="{'selected': log[selectedType] === selectedEvent, 'selectedDetail' : selectedAppointmentDetail !== undefined && log[selectedType].appointment !== undefined ? log[selectedType].appointment[selectedAppointmentDetail] : false}"
        >
          <td
              style="vertical-align: middle; font-size: 12px; width: 10%">{{log[selectedType].entityType}}
          </td>
          <td style="vertical-align: middle; font-size: 12px; width: 15%">
              <span *ngIf="selectedTimeZone === 'UTC'">
                {{ log[selectedType].timestamp |  amUtc |  amDateFormat:'YYYY-MM-DD[T]HH:mm:ss[Z]' }}
              </span>

              <span *ngIf="selectedTimeZone !== 'UTC'">
                {{ log[selectedType].timestamp | amDateFormat:'MM/DD/YYYY h:mm a' }}
              </span>
          </td>
          <td style="vertical-align: middle; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 75%;">
            <span>{{log[selectedType].description}}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="rowexpansion" let-log let-columns="columns">
        <tr class="appointmentLogDetails" *ngIf="selectedEvent !== undefined && selectedEvent.eventId === log[selectedType].eventId">
          <td style="border-top: 0; padding: 0; width: 100%;" colspan="3">
            <div class="detailContent">
              {{log[selectedType].description}}
              <button class="btn btn-link" *ngIf="log[selectedType].xmlIdList !== undefined && log[selectedType].xmlIdList.length > 0"
                      aria-hidden="true"
                      tooltip="View xml log" (click)="showXmlLog(log[selectedType].xmlIdList)">
                <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>